export const version = 'quarterly';
export const libraries = ['geometry', 'places', 'marker'];
export const googleMapsApiKey = 'AIzaSyBg3iYyycTNutbbCzFmhd5W_kt4eodjbIQ';

// Vector Map IDs provisioned in Cloud Console, one per style in window.config.map.mapStylers
// (src/constants/config.js) - shared across all tenants and environments, since mapStylers.default/
// poisOn is identical for every deployment (see DOT-4736 memory notes).
export const mapIds = {
  default: '825058ad479ef6fe32df54c8',
  poisOn: '825058ad479ef6fe69e1c1a2'
};
